/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Categories_InputInputs */

const vi_shop_group_categories_input = /** @type {(inputs: Shop_Group_Categories_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán (chọn nhiều)`)
};

/**

* @param {Shop_Group_Categories_InputInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_categories_input = /** @type {((inputs?: Shop_Group_Categories_InputInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Categories_InputInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_categories_input(inputs)
});